import { Box, Button, Center, Heading, Text, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { FiChevronRight, FiFileText } from "react-icons/fi";
import { ButtonBack, Layout } from "../../../components";
import { useIsAuth } from "../../../hooks/useIsAuth";

const DocumentosMotorista = () => {
  useIsAuth();
  const navigate = useNavigate();

  return (
    <Layout canLogout={true} showFooter={true} backTo="/cargas" title={<ButtonBack to="/cargas" />}>
      <VStack spacing={6} align="stretch" px={2} pb={8} pt={2} maxW="600px" mx="auto">
        <Center>
          <Heading size="md" textAlign="center" color="gray.800" _dark={{ color: "gray.100" }}>
            Documentos
          </Heading>
        </Center>

        <Box
          bg="white"
          borderRadius="md"
          p={4}
          borderWidth="1px"
          borderColor="gray.200"
          shadow="md"
          _dark={{ bg: "gray.700", borderColor: "gray.600" }}
        >
          <Text fontSize="xs" fontWeight="600" color="gray.500" _dark={{ color: "gray.400" }} textTransform="uppercase" letterSpacing="wide" mb={3}>
            Imposto de Renda
          </Text>
          <Button
            width="full"
            colorScheme="blue"
            size="lg"
            py={8}
            h="auto"
            whiteSpace="normal"
            leftIcon={<FiFileText size={28} />}
            rightIcon={<FiChevronRight size={22} />}
            onClick={() => navigate("/informe-rendimentos")}
          >
            <Text as="span" textAlign="left" lineHeight="short">
              Informe de rendimentos (IR)
              <Text as="span" display="block" fontSize="sm" fontWeight="normal" opacity={0.95} mt={1}>
                Documento para declaração do Imposto de Renda para quem é pessoa física (CPF).
              </Text>
            </Text>
          </Button>
        </Box>
      </VStack>
    </Layout>
  );
};

export default DocumentosMotorista;
